<template>
  <BuyerOneColumnLot
    :title="title"
    subTitle="Acompanhe seus lotes!"
    :icon="icon"
    :section="section"
    :description="description"
    :getContent="getLotsRealized"
    labelCard="Comprado por"
    noVehicleLabel="Você ainda não avaliou Lotes…"
  />
</template>

<script>
import { BUYER_SECTION_CLOSED } from "@/views/buyer/constants/BuyerSections";
import PlatformsMixins from "@/mixins/PlatformsMixins";
import BuyerComponentPagesMixins from "@/mixins/BuyerComponentPagesMixins";
import BuyerOneColumnLot from "../../BuyerOneColumnLot";
import { getLotsRealized } from "@/services/api/BuyerServiceApi";

export default {
  name: "LotsCompletedPurchasesPage",
  mixins: [PlatformsMixins, BuyerComponentPagesMixins],
  components: { BuyerOneColumnLot },
  data: function () {
    return {
      ...BUYER_SECTION_CLOSED,
      title:"Compras concretizadas > Lotes",
      section: "Encerrados"
    };
  },
  methods: {
    getLotsRealized,
  },
};
</script>

<style scoped>
.lots-completed-purchases-page {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.lots-completed-purchases-page-top {
  width: 100%;
}

.lots-completed-purchases-page-content {
  margin-top: 4px;
  background-color: white;
  flex: 1;
}
</style>
